/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createCERTIFICATE = /* GraphQL */ `
  mutation CreateCERTIFICATE(
    $input: CreateCERTIFICATEInput!
    $condition: ModelCERTIFICATEConditionInput
  ) {
    createCERTIFICATE(input: $input, condition: $condition) {
      id
      name
      certificateType
      parentCertificateId
      coverageType
      childCertificates {
        nextToken
        scannedCount
        __typename
      }
      clientVendorID
      clientID
      projectID
      certificateDate
      firstExp
      producerName
      producer
      producerAddress1
      producerAddress2
      producerCity
      producerState
      producerZip
      producerContactName
      producerPhone
      producerFax
      producerEmail
      insured
      insuredName
      insuredAddress1
      insuredAddress2
      insuredCity
      insuredState
      insuredZip
      descriptionOfOperation
      certificateHolder
      certificateHolderName
      certificateHolderAddress1
      certificateHolderAddress2
      certificateHolderCity
      certificateHolderState
      certificateHolderZip
      insurerA
      insurerB
      insurerC
      insurerD
      insurerE
      insurerF
      insurerANAIC
      insurerBNAIC
      insurerCNAIC
      insurerDNAIC
      insurerENAIC
      insurerFNAIC
      coverages {
        nextToken
        __typename
      }
      files
      supplementalCoiFiles
      acord25File
      acord25FileDate
      comments
      imported
      status
      previousId
      updatedAt
      createdAt
      initialCoverageRequirements
      initialDescriptionOfOperation
      overrides
      sentBy
      redirectedBy
      sentTo
      readBy
      additionalInformation
      extractionMethod
      extractionModel
      extractionConfidence
      extractionMetadata
      reprocessedCount
      __typename
    }
  }
`;
export const updateCERTIFICATE = /* GraphQL */ `
  mutation UpdateCERTIFICATE(
    $input: UpdateCERTIFICATEInput!
    $condition: ModelCERTIFICATEConditionInput
  ) {
    updateCERTIFICATE(input: $input, condition: $condition) {
      id
      name
      certificateType
      parentCertificateId
      coverageType
      childCertificates {
        nextToken
        scannedCount
        __typename
      }
      clientVendorID
      clientID
      projectID
      certificateDate
      firstExp
      producerName
      producer
      producerAddress1
      producerAddress2
      producerCity
      producerState
      producerZip
      producerContactName
      producerPhone
      producerFax
      producerEmail
      insured
      insuredName
      insuredAddress1
      insuredAddress2
      insuredCity
      insuredState
      insuredZip
      descriptionOfOperation
      certificateHolder
      certificateHolderName
      certificateHolderAddress1
      certificateHolderAddress2
      certificateHolderCity
      certificateHolderState
      certificateHolderZip
      insurerA
      insurerB
      insurerC
      insurerD
      insurerE
      insurerF
      insurerANAIC
      insurerBNAIC
      insurerCNAIC
      insurerDNAIC
      insurerENAIC
      insurerFNAIC
      coverages {
        nextToken
        __typename
      }
      files
      supplementalCoiFiles
      acord25File
      acord25FileDate
      comments
      imported
      status
      previousId
      updatedAt
      createdAt
      initialCoverageRequirements
      initialDescriptionOfOperation
      overrides
      sentBy
      redirectedBy
      sentTo
      readBy
      additionalInformation
      extractionMethod
      extractionModel
      extractionConfidence
      extractionMetadata
      reprocessedCount
      __typename
    }
  }
`;
export const deleteCERTIFICATE = /* GraphQL */ `
  mutation DeleteCERTIFICATE(
    $input: DeleteCERTIFICATEInput!
    $condition: ModelCERTIFICATEConditionInput
  ) {
    deleteCERTIFICATE(input: $input, condition: $condition) {
      id
      name
      certificateType
      parentCertificateId
      coverageType
      childCertificates {
        nextToken
        scannedCount
        __typename
      }
      clientVendorID
      clientID
      projectID
      certificateDate
      firstExp
      producerName
      producer
      producerAddress1
      producerAddress2
      producerCity
      producerState
      producerZip
      producerContactName
      producerPhone
      producerFax
      producerEmail
      insured
      insuredName
      insuredAddress1
      insuredAddress2
      insuredCity
      insuredState
      insuredZip
      descriptionOfOperation
      certificateHolder
      certificateHolderName
      certificateHolderAddress1
      certificateHolderAddress2
      certificateHolderCity
      certificateHolderState
      certificateHolderZip
      insurerA
      insurerB
      insurerC
      insurerD
      insurerE
      insurerF
      insurerANAIC
      insurerBNAIC
      insurerCNAIC
      insurerDNAIC
      insurerENAIC
      insurerFNAIC
      coverages {
        nextToken
        __typename
      }
      files
      supplementalCoiFiles
      acord25File
      acord25FileDate
      comments
      imported
      status
      previousId
      updatedAt
      createdAt
      initialCoverageRequirements
      initialDescriptionOfOperation
      overrides
      sentBy
      redirectedBy
      sentTo
      readBy
      additionalInformation
      extractionMethod
      extractionModel
      extractionConfidence
      extractionMetadata
      reprocessedCount
      __typename
    }
  }
`;
export const createCERTIFICATECOVERAGE = /* GraphQL */ `
  mutation CreateCERTIFICATECOVERAGE(
    $input: CreateCERTIFICATECOVERAGEInput!
    $condition: ModelCERTIFICATECOVERAGEConditionInput
  ) {
    createCERTIFICATECOVERAGE(input: $input, condition: $condition) {
      id
      name
      certificateID
      insuranceType
      insuranceForm
      aggregateAppliesPer
      coveredProperty
      additionalInsured
      subrogationWaiver
      deductible
      retention
      exclusion
      limits
      overrides
      limitPerStatute
      policyEff
      policyExp
      policyNumber
      insurerLetter
      selectedCoverage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCERTIFICATECOVERAGE = /* GraphQL */ `
  mutation UpdateCERTIFICATECOVERAGE(
    $input: UpdateCERTIFICATECOVERAGEInput!
    $condition: ModelCERTIFICATECOVERAGEConditionInput
  ) {
    updateCERTIFICATECOVERAGE(input: $input, condition: $condition) {
      id
      name
      certificateID
      insuranceType
      insuranceForm
      aggregateAppliesPer
      coveredProperty
      additionalInsured
      subrogationWaiver
      deductible
      retention
      exclusion
      limits
      overrides
      limitPerStatute
      policyEff
      policyExp
      policyNumber
      insurerLetter
      selectedCoverage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCERTIFICATECOVERAGE = /* GraphQL */ `
  mutation DeleteCERTIFICATECOVERAGE(
    $input: DeleteCERTIFICATECOVERAGEInput!
    $condition: ModelCERTIFICATECOVERAGEConditionInput
  ) {
    deleteCERTIFICATECOVERAGE(input: $input, condition: $condition) {
      id
      name
      certificateID
      insuranceType
      insuranceForm
      aggregateAppliesPer
      coveredProperty
      additionalInsured
      subrogationWaiver
      deductible
      retention
      exclusion
      limits
      overrides
      limitPerStatute
      policyEff
      policyExp
      policyNumber
      insurerLetter
      selectedCoverage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createVENDORCOVERAGE = /* GraphQL */ `
  mutation CreateVENDORCOVERAGE(
    $input: CreateVENDORCOVERAGEInput!
    $condition: ModelVENDORCOVERAGEConditionInput
  ) {
    createVENDORCOVERAGE(input: $input, condition: $condition) {
      id
      name
      clientVendorID
      categoryID
      clientCoverageID
      insuranceType
      insuranceForm
      aggregateAppliesPer
      coveredProperty
      additionalInsured
      subrogationWaiver
      deductible
      retention
      exclusion
      limits
      limitPerStatute
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateVENDORCOVERAGE = /* GraphQL */ `
  mutation UpdateVENDORCOVERAGE(
    $input: UpdateVENDORCOVERAGEInput!
    $condition: ModelVENDORCOVERAGEConditionInput
  ) {
    updateVENDORCOVERAGE(input: $input, condition: $condition) {
      id
      name
      clientVendorID
      categoryID
      clientCoverageID
      insuranceType
      insuranceForm
      aggregateAppliesPer
      coveredProperty
      additionalInsured
      subrogationWaiver
      deductible
      retention
      exclusion
      limits
      limitPerStatute
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteVENDORCOVERAGE = /* GraphQL */ `
  mutation DeleteVENDORCOVERAGE(
    $input: DeleteVENDORCOVERAGEInput!
    $condition: ModelVENDORCOVERAGEConditionInput
  ) {
    deleteVENDORCOVERAGE(input: $input, condition: $condition) {
      id
      name
      clientVendorID
      categoryID
      clientCoverageID
      insuranceType
      insuranceForm
      aggregateAppliesPer
      coveredProperty
      additionalInsured
      subrogationWaiver
      deductible
      retention
      exclusion
      limits
      limitPerStatute
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCLIENTCOVERAGE = /* GraphQL */ `
  mutation CreateCLIENTCOVERAGE(
    $input: CreateCLIENTCOVERAGEInput!
    $condition: ModelCLIENTCOVERAGEConditionInput
  ) {
    createCLIENTCOVERAGE(input: $input, condition: $condition) {
      id
      name
      clientID
      insuranceType
      insuranceForm
      aggregateAppliesPer
      coveredProperty
      additionalInsured
      subrogationWaiver
      deductible
      retention
      exclusion
      limits
      limitPerStatute
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCLIENTCOVERAGE = /* GraphQL */ `
  mutation UpdateCLIENTCOVERAGE(
    $input: UpdateCLIENTCOVERAGEInput!
    $condition: ModelCLIENTCOVERAGEConditionInput
  ) {
    updateCLIENTCOVERAGE(input: $input, condition: $condition) {
      id
      name
      clientID
      insuranceType
      insuranceForm
      aggregateAppliesPer
      coveredProperty
      additionalInsured
      subrogationWaiver
      deductible
      retention
      exclusion
      limits
      limitPerStatute
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCLIENTCOVERAGE = /* GraphQL */ `
  mutation DeleteCLIENTCOVERAGE(
    $input: DeleteCLIENTCOVERAGEInput!
    $condition: ModelCLIENTCOVERAGEConditionInput
  ) {
    deleteCLIENTCOVERAGE(input: $input, condition: $condition) {
      id
      name
      clientID
      insuranceType
      insuranceForm
      aggregateAppliesPer
      coveredProperty
      additionalInsured
      subrogationWaiver
      deductible
      retention
      exclusion
      limits
      limitPerStatute
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPROJECT = /* GraphQL */ `
  mutation CreatePROJECT(
    $input: CreatePROJECTInput!
    $condition: ModelPROJECTConditionInput
  ) {
    createPROJECT(input: $input, condition: $condition) {
      id
      name
      startDate
      endDate
      description
      status
      clientID
      requiredCoverages
      requiredDescriptionOfOperation
      vendors {
        nextToken
        __typename
      }
      isDefault
      address
      city
      state
      zip
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePROJECT = /* GraphQL */ `
  mutation UpdatePROJECT(
    $input: UpdatePROJECTInput!
    $condition: ModelPROJECTConditionInput
  ) {
    updatePROJECT(input: $input, condition: $condition) {
      id
      name
      startDate
      endDate
      description
      status
      clientID
      requiredCoverages
      requiredDescriptionOfOperation
      vendors {
        nextToken
        __typename
      }
      isDefault
      address
      city
      state
      zip
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePROJECT = /* GraphQL */ `
  mutation DeletePROJECT(
    $input: DeletePROJECTInput!
    $condition: ModelPROJECTConditionInput
  ) {
    deletePROJECT(input: $input, condition: $condition) {
      id
      name
      startDate
      endDate
      description
      status
      clientID
      requiredCoverages
      requiredDescriptionOfOperation
      vendors {
        nextToken
        __typename
      }
      isDefault
      address
      city
      state
      zip
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPROJECTVENDORS = /* GraphQL */ `
  mutation CreatePROJECTVENDORS(
    $input: CreatePROJECTVENDORSInput!
    $condition: ModelPROJECTVENDORSConditionInput
  ) {
    createPROJECTVENDORS(input: $input, condition: $condition) {
      id
      projectID
      PROJECT {
        id
        name
        startDate
        endDate
        description
        status
        clientID
        requiredCoverages
        requiredDescriptionOfOperation
        isDefault
        address
        city
        state
        zip
        createdAt
        updatedAt
        __typename
      }
      clientVendorID
      clientVendor {
        id
        starred
        clientID
        vendorID
        status
        notificationStatus
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePROJECTVENDORS = /* GraphQL */ `
  mutation UpdatePROJECTVENDORS(
    $input: UpdatePROJECTVENDORSInput!
    $condition: ModelPROJECTVENDORSConditionInput
  ) {
    updatePROJECTVENDORS(input: $input, condition: $condition) {
      id
      projectID
      PROJECT {
        id
        name
        startDate
        endDate
        description
        status
        clientID
        requiredCoverages
        requiredDescriptionOfOperation
        isDefault
        address
        city
        state
        zip
        createdAt
        updatedAt
        __typename
      }
      clientVendorID
      clientVendor {
        id
        starred
        clientID
        vendorID
        status
        notificationStatus
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePROJECTVENDORS = /* GraphQL */ `
  mutation DeletePROJECTVENDORS(
    $input: DeletePROJECTVENDORSInput!
    $condition: ModelPROJECTVENDORSConditionInput
  ) {
    deletePROJECTVENDORS(input: $input, condition: $condition) {
      id
      projectID
      PROJECT {
        id
        name
        startDate
        endDate
        description
        status
        clientID
        requiredCoverages
        requiredDescriptionOfOperation
        isDefault
        address
        city
        state
        zip
        createdAt
        updatedAt
        __typename
      }
      clientVendorID
      clientVendor {
        id
        starred
        clientID
        vendorID
        status
        notificationStatus
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCLIENTVENDORS = /* GraphQL */ `
  mutation CreateCLIENTVENDORS(
    $input: CreateCLIENTVENDORSInput!
    $condition: ModelCLIENTVENDORSConditionInput
  ) {
    createCLIENTVENDORS(input: $input, condition: $condition) {
      id
      starred
      clientID
      vendor {
        id
        name
        useEntityName
        entityName
        email
        additionalEmails
        ein
        phone
        logo
        address1
        address2
        city
        state
        zip
        createdAt
        updatedAt
        vENDORInsuranceAgentId
        __typename
      }
      vendorID
      status
      notificationStatus
      vendorCoverages {
        nextToken
        __typename
      }
      certificates {
        nextToken
        scannedCount
        __typename
      }
      projects {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCLIENTVENDORS = /* GraphQL */ `
  mutation UpdateCLIENTVENDORS(
    $input: UpdateCLIENTVENDORSInput!
    $condition: ModelCLIENTVENDORSConditionInput
  ) {
    updateCLIENTVENDORS(input: $input, condition: $condition) {
      id
      starred
      clientID
      vendor {
        id
        name
        useEntityName
        entityName
        email
        additionalEmails
        ein
        phone
        logo
        address1
        address2
        city
        state
        zip
        createdAt
        updatedAt
        vENDORInsuranceAgentId
        __typename
      }
      vendorID
      status
      notificationStatus
      vendorCoverages {
        nextToken
        __typename
      }
      certificates {
        nextToken
        scannedCount
        __typename
      }
      projects {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCLIENTVENDORS = /* GraphQL */ `
  mutation DeleteCLIENTVENDORS(
    $input: DeleteCLIENTVENDORSInput!
    $condition: ModelCLIENTVENDORSConditionInput
  ) {
    deleteCLIENTVENDORS(input: $input, condition: $condition) {
      id
      starred
      clientID
      vendor {
        id
        name
        useEntityName
        entityName
        email
        additionalEmails
        ein
        phone
        logo
        address1
        address2
        city
        state
        zip
        createdAt
        updatedAt
        vENDORInsuranceAgentId
        __typename
      }
      vendorID
      status
      notificationStatus
      vendorCoverages {
        nextToken
        __typename
      }
      certificates {
        nextToken
        scannedCount
        __typename
      }
      projects {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createINSURANCEAGENT = /* GraphQL */ `
  mutation CreateINSURANCEAGENT(
    $input: CreateINSURANCEAGENTInput!
    $condition: ModelINSURANCEAGENTConditionInput
  ) {
    createINSURANCEAGENT(input: $input, condition: $condition) {
      id
      name
      phone
      email
      address1
      address2
      city
      state
      zip
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateINSURANCEAGENT = /* GraphQL */ `
  mutation UpdateINSURANCEAGENT(
    $input: UpdateINSURANCEAGENTInput!
    $condition: ModelINSURANCEAGENTConditionInput
  ) {
    updateINSURANCEAGENT(input: $input, condition: $condition) {
      id
      name
      phone
      email
      address1
      address2
      city
      state
      zip
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteINSURANCEAGENT = /* GraphQL */ `
  mutation DeleteINSURANCEAGENT(
    $input: DeleteINSURANCEAGENTInput!
    $condition: ModelINSURANCEAGENTConditionInput
  ) {
    deleteINSURANCEAGENT(input: $input, condition: $condition) {
      id
      name
      phone
      email
      address1
      address2
      city
      state
      zip
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createVENDOR = /* GraphQL */ `
  mutation CreateVENDOR(
    $input: CreateVENDORInput!
    $condition: ModelVENDORConditionInput
  ) {
    createVENDOR(input: $input, condition: $condition) {
      id
      name
      useEntityName
      entityName
      email
      additionalEmails
      ein
      phone
      logo
      address1
      address2
      city
      state
      zip
      insuranceAgent {
        id
        name
        phone
        email
        address1
        address2
        city
        state
        zip
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      vENDORInsuranceAgentId
      __typename
    }
  }
`;
export const updateVENDOR = /* GraphQL */ `
  mutation UpdateVENDOR(
    $input: UpdateVENDORInput!
    $condition: ModelVENDORConditionInput
  ) {
    updateVENDOR(input: $input, condition: $condition) {
      id
      name
      useEntityName
      entityName
      email
      additionalEmails
      ein
      phone
      logo
      address1
      address2
      city
      state
      zip
      insuranceAgent {
        id
        name
        phone
        email
        address1
        address2
        city
        state
        zip
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      vENDORInsuranceAgentId
      __typename
    }
  }
`;
export const deleteVENDOR = /* GraphQL */ `
  mutation DeleteVENDOR(
    $input: DeleteVENDORInput!
    $condition: ModelVENDORConditionInput
  ) {
    deleteVENDOR(input: $input, condition: $condition) {
      id
      name
      useEntityName
      entityName
      email
      additionalEmails
      ein
      phone
      logo
      address1
      address2
      city
      state
      zip
      insuranceAgent {
        id
        name
        phone
        email
        address1
        address2
        city
        state
        zip
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      vENDORInsuranceAgentId
      __typename
    }
  }
`;
export const createUSER = /* GraphQL */ `
  mutation CreateUSER(
    $input: CreateUSERInput!
    $condition: ModelUSERConditionInput
  ) {
    createUSER(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      role
      organizationID
      userOrganization {
        id
        name
        vendorLabel
        projectLabel
        clientLabel
        certificateHolder
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        themeColor
        logo
        isAgency
        useDefaultProject
        usePrimaryNotificationEmailAddress
        primaryNotificationEmailAddress
        tableRowsPerPage
        email
        type
        adminName
        adminEmail
        phone
        address1
        address2
        city
        state
        zip
        website
        createdAt
        updatedAt
        __typename
      }
      status
      assignedVendors
      lastLoginAt
      lastActiveAt
      cognitoCreatedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUSER = /* GraphQL */ `
  mutation UpdateUSER(
    $input: UpdateUSERInput!
    $condition: ModelUSERConditionInput
  ) {
    updateUSER(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      role
      organizationID
      userOrganization {
        id
        name
        vendorLabel
        projectLabel
        clientLabel
        certificateHolder
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        themeColor
        logo
        isAgency
        useDefaultProject
        usePrimaryNotificationEmailAddress
        primaryNotificationEmailAddress
        tableRowsPerPage
        email
        type
        adminName
        adminEmail
        phone
        address1
        address2
        city
        state
        zip
        website
        createdAt
        updatedAt
        __typename
      }
      status
      assignedVendors
      lastLoginAt
      lastActiveAt
      cognitoCreatedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUSER = /* GraphQL */ `
  mutation DeleteUSER(
    $input: DeleteUSERInput!
    $condition: ModelUSERConditionInput
  ) {
    deleteUSER(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      role
      organizationID
      userOrganization {
        id
        name
        vendorLabel
        projectLabel
        clientLabel
        certificateHolder
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        themeColor
        logo
        isAgency
        useDefaultProject
        usePrimaryNotificationEmailAddress
        primaryNotificationEmailAddress
        tableRowsPerPage
        email
        type
        adminName
        adminEmail
        phone
        address1
        address2
        city
        state
        zip
        website
        createdAt
        updatedAt
        __typename
      }
      status
      assignedVendors
      lastLoginAt
      lastActiveAt
      cognitoCreatedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCLIENT = /* GraphQL */ `
  mutation CreateCLIENT(
    $input: CreateCLIENTInput!
    $condition: ModelCLIENTConditionInput
  ) {
    createCLIENT(input: $input, condition: $condition) {
      id
      organizationID
      agencyOrganizationID
      mode
      clientOrganization {
        id
        name
        vendorLabel
        projectLabel
        clientLabel
        certificateHolder
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        themeColor
        logo
        isAgency
        useDefaultProject
        usePrimaryNotificationEmailAddress
        primaryNotificationEmailAddress
        tableRowsPerPage
        email
        type
        adminName
        adminEmail
        phone
        address1
        address2
        city
        state
        zip
        website
        createdAt
        updatedAt
        __typename
      }
      clientVendors {
        nextToken
        __typename
      }
      clientProjects {
        nextToken
        __typename
      }
      clientCoverages {
        nextToken
        __typename
      }
      templates
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCLIENT = /* GraphQL */ `
  mutation UpdateCLIENT(
    $input: UpdateCLIENTInput!
    $condition: ModelCLIENTConditionInput
  ) {
    updateCLIENT(input: $input, condition: $condition) {
      id
      organizationID
      agencyOrganizationID
      mode
      clientOrganization {
        id
        name
        vendorLabel
        projectLabel
        clientLabel
        certificateHolder
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        themeColor
        logo
        isAgency
        useDefaultProject
        usePrimaryNotificationEmailAddress
        primaryNotificationEmailAddress
        tableRowsPerPage
        email
        type
        adminName
        adminEmail
        phone
        address1
        address2
        city
        state
        zip
        website
        createdAt
        updatedAt
        __typename
      }
      clientVendors {
        nextToken
        __typename
      }
      clientProjects {
        nextToken
        __typename
      }
      clientCoverages {
        nextToken
        __typename
      }
      templates
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCLIENT = /* GraphQL */ `
  mutation DeleteCLIENT(
    $input: DeleteCLIENTInput!
    $condition: ModelCLIENTConditionInput
  ) {
    deleteCLIENT(input: $input, condition: $condition) {
      id
      organizationID
      agencyOrganizationID
      mode
      clientOrganization {
        id
        name
        vendorLabel
        projectLabel
        clientLabel
        certificateHolder
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        themeColor
        logo
        isAgency
        useDefaultProject
        usePrimaryNotificationEmailAddress
        primaryNotificationEmailAddress
        tableRowsPerPage
        email
        type
        adminName
        adminEmail
        phone
        address1
        address2
        city
        state
        zip
        website
        createdAt
        updatedAt
        __typename
      }
      clientVendors {
        nextToken
        __typename
      }
      clientProjects {
        nextToken
        __typename
      }
      clientCoverages {
        nextToken
        __typename
      }
      templates
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createORGANIZATION = /* GraphQL */ `
  mutation CreateORGANIZATION(
    $input: CreateORGANIZATIONInput!
    $condition: ModelORGANIZATIONConditionInput
  ) {
    createORGANIZATION(input: $input, condition: $condition) {
      id
      name
      vendorLabel
      projectLabel
      clientLabel
      certificateHolder
      certificateHolderAddress1
      certificateHolderAddress2
      certificateHolderCity
      certificateHolderState
      certificateHolderZip
      themeColor
      logo
      isAgency
      useDefaultProject
      usePrimaryNotificationEmailAddress
      primaryNotificationEmailAddress
      tableRowsPerPage
      organizationUsers {
        nextToken
        __typename
      }
      email
      type
      adminName
      adminEmail
      phone
      address1
      address2
      city
      state
      zip
      website
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateORGANIZATION = /* GraphQL */ `
  mutation UpdateORGANIZATION(
    $input: UpdateORGANIZATIONInput!
    $condition: ModelORGANIZATIONConditionInput
  ) {
    updateORGANIZATION(input: $input, condition: $condition) {
      id
      name
      vendorLabel
      projectLabel
      clientLabel
      certificateHolder
      certificateHolderAddress1
      certificateHolderAddress2
      certificateHolderCity
      certificateHolderState
      certificateHolderZip
      themeColor
      logo
      isAgency
      useDefaultProject
      usePrimaryNotificationEmailAddress
      primaryNotificationEmailAddress
      tableRowsPerPage
      organizationUsers {
        nextToken
        __typename
      }
      email
      type
      adminName
      adminEmail
      phone
      address1
      address2
      city
      state
      zip
      website
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteORGANIZATION = /* GraphQL */ `
  mutation DeleteORGANIZATION(
    $input: DeleteORGANIZATIONInput!
    $condition: ModelORGANIZATIONConditionInput
  ) {
    deleteORGANIZATION(input: $input, condition: $condition) {
      id
      name
      vendorLabel
      projectLabel
      clientLabel
      certificateHolder
      certificateHolderAddress1
      certificateHolderAddress2
      certificateHolderCity
      certificateHolderState
      certificateHolderZip
      themeColor
      logo
      isAgency
      useDefaultProject
      usePrimaryNotificationEmailAddress
      primaryNotificationEmailAddress
      tableRowsPerPage
      organizationUsers {
        nextToken
        __typename
      }
      email
      type
      adminName
      adminEmail
      phone
      address1
      address2
      city
      state
      zip
      website
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createANTHROPICSETTINGS = /* GraphQL */ `
  mutation CreateANTHROPICSETTINGS(
    $input: CreateANTHROPICSETTINGSInput!
    $condition: ModelANTHROPICSETTINGSConditionInput
  ) {
    createANTHROPICSETTINGS(input: $input, condition: $condition) {
      id
      organizationID
      clientID
      enabled
      defaultModel
      extractionStrategy
      fallbackToOCR
      confidenceThreshold
      maxTokens
      temperature
      enableFieldConfidence
      createdAt
      updatedAt
      createdBy
      updatedBy
      __typename
    }
  }
`;
export const updateANTHROPICSETTINGS = /* GraphQL */ `
  mutation UpdateANTHROPICSETTINGS(
    $input: UpdateANTHROPICSETTINGSInput!
    $condition: ModelANTHROPICSETTINGSConditionInput
  ) {
    updateANTHROPICSETTINGS(input: $input, condition: $condition) {
      id
      organizationID
      clientID
      enabled
      defaultModel
      extractionStrategy
      fallbackToOCR
      confidenceThreshold
      maxTokens
      temperature
      enableFieldConfidence
      createdAt
      updatedAt
      createdBy
      updatedBy
      __typename
    }
  }
`;
export const deleteANTHROPICSETTINGS = /* GraphQL */ `
  mutation DeleteANTHROPICSETTINGS(
    $input: DeleteANTHROPICSETTINGSInput!
    $condition: ModelANTHROPICSETTINGSConditionInput
  ) {
    deleteANTHROPICSETTINGS(input: $input, condition: $condition) {
      id
      organizationID
      clientID
      enabled
      defaultModel
      extractionStrategy
      fallbackToOCR
      confidenceThreshold
      maxTokens
      temperature
      enableFieldConfidence
      createdAt
      updatedAt
      createdBy
      updatedBy
      __typename
    }
  }
`;
export const createEMAILNOTIFICATIONS = /* GraphQL */ `
  mutation CreateEMAILNOTIFICATIONS(
    $input: CreateEMAILNOTIFICATIONSInput!
    $condition: ModelEMAILNOTIFICATIONSConditionInput
  ) {
    createEMAILNOTIFICATIONS(input: $input, condition: $condition) {
      id
      recipients
      action
      vendorName
      clientName
      uploadLink
      subject
      content
      greeting
      signature
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateEMAILNOTIFICATIONS = /* GraphQL */ `
  mutation UpdateEMAILNOTIFICATIONS(
    $input: UpdateEMAILNOTIFICATIONSInput!
    $condition: ModelEMAILNOTIFICATIONSConditionInput
  ) {
    updateEMAILNOTIFICATIONS(input: $input, condition: $condition) {
      id
      recipients
      action
      vendorName
      clientName
      uploadLink
      subject
      content
      greeting
      signature
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteEMAILNOTIFICATIONS = /* GraphQL */ `
  mutation DeleteEMAILNOTIFICATIONS(
    $input: DeleteEMAILNOTIFICATIONSInput!
    $condition: ModelEMAILNOTIFICATIONSConditionInput
  ) {
    deleteEMAILNOTIFICATIONS(input: $input, condition: $condition) {
      id
      recipients
      action
      vendorName
      clientName
      uploadLink
      subject
      content
      greeting
      signature
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSCHEDULEDEMAILS = /* GraphQL */ `
  mutation CreateSCHEDULEDEMAILS(
    $input: CreateSCHEDULEDEMAILSInput!
    $condition: ModelSCHEDULEDEMAILSConditionInput
  ) {
    createSCHEDULEDEMAILS(input: $input, condition: $condition) {
      id
      scheduledDate
      clientID
      vendorID
      certificateID
      recipients
      action
      vendorName
      clientName
      uploadLink
      subject
      content
      greeting
      signature
      status
      emailNotificationID
      certificateStatus
      vendorStatus
      expirationDate
      reminderType
      pausedAt
      pausedBy
      cancelledAt
      cancelledBy
      sentAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSCHEDULEDEMAILS = /* GraphQL */ `
  mutation UpdateSCHEDULEDEMAILS(
    $input: UpdateSCHEDULEDEMAILSInput!
    $condition: ModelSCHEDULEDEMAILSConditionInput
  ) {
    updateSCHEDULEDEMAILS(input: $input, condition: $condition) {
      id
      scheduledDate
      clientID
      vendorID
      certificateID
      recipients
      action
      vendorName
      clientName
      uploadLink
      subject
      content
      greeting
      signature
      status
      emailNotificationID
      certificateStatus
      vendorStatus
      expirationDate
      reminderType
      pausedAt
      pausedBy
      cancelledAt
      cancelledBy
      sentAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSCHEDULEDEMAILS = /* GraphQL */ `
  mutation DeleteSCHEDULEDEMAILS(
    $input: DeleteSCHEDULEDEMAILSInput!
    $condition: ModelSCHEDULEDEMAILSConditionInput
  ) {
    deleteSCHEDULEDEMAILS(input: $input, condition: $condition) {
      id
      scheduledDate
      clientID
      vendorID
      certificateID
      recipients
      action
      vendorName
      clientName
      uploadLink
      subject
      content
      greeting
      signature
      status
      emailNotificationID
      certificateStatus
      vendorStatus
      expirationDate
      reminderType
      pausedAt
      pausedBy
      cancelledAt
      cancelledBy
      sentAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createACORD25SCAN = /* GraphQL */ `
  mutation CreateACORD25SCAN(
    $input: CreateACORD25SCANInput!
    $condition: ModelACORD25SCANConditionInput
  ) {
    createACORD25SCAN(input: $input, condition: $condition) {
      id
      certificateID
      certificateDate
      producer
      producerContactName
      producerPhone
      producerFax
      producerEmail
      insured
      descriptionOfOperation
      certificateHolder
      insurerA
      insurerB
      insurerC
      insurerD
      insurerE
      insurerF
      insurerANAIC
      insurerBNAIC
      insurerCNAIC
      insurerDNAIC
      insurerENAIC
      insurerFNAIC
      coverages {
        nextToken
        __typename
      }
      acord25File
      status
      scanStage
      uploadLink
      uploaderName
      uploaderEmail
      scanError
      scanConfidence
      fieldConfidence
      extractionMethod
      extractionModel
      extractionConfidence
      extractionMetadata
      reprocessedCount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateACORD25SCAN = /* GraphQL */ `
  mutation UpdateACORD25SCAN(
    $input: UpdateACORD25SCANInput!
    $condition: ModelACORD25SCANConditionInput
  ) {
    updateACORD25SCAN(input: $input, condition: $condition) {
      id
      certificateID
      certificateDate
      producer
      producerContactName
      producerPhone
      producerFax
      producerEmail
      insured
      descriptionOfOperation
      certificateHolder
      insurerA
      insurerB
      insurerC
      insurerD
      insurerE
      insurerF
      insurerANAIC
      insurerBNAIC
      insurerCNAIC
      insurerDNAIC
      insurerENAIC
      insurerFNAIC
      coverages {
        nextToken
        __typename
      }
      acord25File
      status
      scanStage
      uploadLink
      uploaderName
      uploaderEmail
      scanError
      scanConfidence
      fieldConfidence
      extractionMethod
      extractionModel
      extractionConfidence
      extractionMetadata
      reprocessedCount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteACORD25SCAN = /* GraphQL */ `
  mutation DeleteACORD25SCAN(
    $input: DeleteACORD25SCANInput!
    $condition: ModelACORD25SCANConditionInput
  ) {
    deleteACORD25SCAN(input: $input, condition: $condition) {
      id
      certificateID
      certificateDate
      producer
      producerContactName
      producerPhone
      producerFax
      producerEmail
      insured
      descriptionOfOperation
      certificateHolder
      insurerA
      insurerB
      insurerC
      insurerD
      insurerE
      insurerF
      insurerANAIC
      insurerBNAIC
      insurerCNAIC
      insurerDNAIC
      insurerENAIC
      insurerFNAIC
      coverages {
        nextToken
        __typename
      }
      acord25File
      status
      scanStage
      uploadLink
      uploaderName
      uploaderEmail
      scanError
      scanConfidence
      fieldConfidence
      extractionMethod
      extractionModel
      extractionConfidence
      extractionMetadata
      reprocessedCount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createACORD25SCANCOVERAGE = /* GraphQL */ `
  mutation CreateACORD25SCANCOVERAGE(
    $input: CreateACORD25SCANCOVERAGEInput!
    $condition: ModelACORD25SCANCOVERAGEConditionInput
  ) {
    createACORD25SCANCOVERAGE(input: $input, condition: $condition) {
      id
      name
      acord25ScanID
      insuranceType
      insuranceForm
      aggregateAppliesPer
      coveredProperty
      additionalInsured
      subrogationWaiver
      deductible
      retention
      exclusion
      limits
      limitPerStatute
      policyEff
      policyExp
      policyNumber
      insurerLetter
      selectedCoverage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateACORD25SCANCOVERAGE = /* GraphQL */ `
  mutation UpdateACORD25SCANCOVERAGE(
    $input: UpdateACORD25SCANCOVERAGEInput!
    $condition: ModelACORD25SCANCOVERAGEConditionInput
  ) {
    updateACORD25SCANCOVERAGE(input: $input, condition: $condition) {
      id
      name
      acord25ScanID
      insuranceType
      insuranceForm
      aggregateAppliesPer
      coveredProperty
      additionalInsured
      subrogationWaiver
      deductible
      retention
      exclusion
      limits
      limitPerStatute
      policyEff
      policyExp
      policyNumber
      insurerLetter
      selectedCoverage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteACORD25SCANCOVERAGE = /* GraphQL */ `
  mutation DeleteACORD25SCANCOVERAGE(
    $input: DeleteACORD25SCANCOVERAGEInput!
    $condition: ModelACORD25SCANCOVERAGEConditionInput
  ) {
    deleteACORD25SCANCOVERAGE(input: $input, condition: $condition) {
      id
      name
      acord25ScanID
      insuranceType
      insuranceForm
      aggregateAppliesPer
      coveredProperty
      additionalInsured
      subrogationWaiver
      deductible
      retention
      exclusion
      limits
      limitPerStatute
      policyEff
      policyExp
      policyNumber
      insurerLetter
      selectedCoverage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createACTIVITY = /* GraphQL */ `
  mutation CreateACTIVITY(
    $input: CreateACTIVITYInput!
    $condition: ModelACTIVITYConditionInput
  ) {
    createACTIVITY(input: $input, condition: $condition) {
      id
      entity
      entityID
      userFullName
      userID
      action
      field
      value
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateACTIVITY = /* GraphQL */ `
  mutation UpdateACTIVITY(
    $input: UpdateACTIVITYInput!
    $condition: ModelACTIVITYConditionInput
  ) {
    updateACTIVITY(input: $input, condition: $condition) {
      id
      entity
      entityID
      userFullName
      userID
      action
      field
      value
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteACTIVITY = /* GraphQL */ `
  mutation DeleteACTIVITY(
    $input: DeleteACTIVITYInput!
    $condition: ModelACTIVITYConditionInput
  ) {
    deleteACTIVITY(input: $input, condition: $condition) {
      id
      entity
      entityID
      userFullName
      userID
      action
      field
      value
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createNOTIFICATION = /* GraphQL */ `
  mutation CreateNOTIFICATION(
    $input: CreateNOTIFICATIONInput!
    $condition: ModelNOTIFICATIONConditionInput
  ) {
    createNOTIFICATION(input: $input, condition: $condition) {
      id
      type
      status
      title
      message
      userID
      organizationID
      certificateID
      vendorID
      clientID
      documentRequestID
      uploadCount
      uploaderName
      uploadedFiles
      metadata
      readAt
      archivedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateNOTIFICATION = /* GraphQL */ `
  mutation UpdateNOTIFICATION(
    $input: UpdateNOTIFICATIONInput!
    $condition: ModelNOTIFICATIONConditionInput
  ) {
    updateNOTIFICATION(input: $input, condition: $condition) {
      id
      type
      status
      title
      message
      userID
      organizationID
      certificateID
      vendorID
      clientID
      documentRequestID
      uploadCount
      uploaderName
      uploadedFiles
      metadata
      readAt
      archivedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteNOTIFICATION = /* GraphQL */ `
  mutation DeleteNOTIFICATION(
    $input: DeleteNOTIFICATIONInput!
    $condition: ModelNOTIFICATIONConditionInput
  ) {
    deleteNOTIFICATION(input: $input, condition: $condition) {
      id
      type
      status
      title
      message
      userID
      organizationID
      certificateID
      vendorID
      clientID
      documentRequestID
      uploadCount
      uploaderName
      uploadedFiles
      metadata
      readAt
      archivedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFILECABINETFOLDER = /* GraphQL */ `
  mutation CreateFILECABINETFOLDER(
    $input: CreateFILECABINETFOLDERInput!
    $condition: ModelFILECABINETFOLDERConditionInput
  ) {
    createFILECABINETFOLDER(input: $input, condition: $condition) {
      id
      name
      description
      parentFolderID
      clientID
      organizationID
      createdBy
      parentFolder {
        id
        name
        description
        parentFolderID
        clientID
        organizationID
        createdBy
        sortOrder
        depth
        itemCount
        lastActivityAt
        createdAt
        updatedAt
        __typename
      }
      subFolders {
        nextToken
        __typename
      }
      folderItems {
        nextToken
        __typename
      }
      sortOrder
      depth
      itemCount
      lastActivityAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFILECABINETFOLDER = /* GraphQL */ `
  mutation UpdateFILECABINETFOLDER(
    $input: UpdateFILECABINETFOLDERInput!
    $condition: ModelFILECABINETFOLDERConditionInput
  ) {
    updateFILECABINETFOLDER(input: $input, condition: $condition) {
      id
      name
      description
      parentFolderID
      clientID
      organizationID
      createdBy
      parentFolder {
        id
        name
        description
        parentFolderID
        clientID
        organizationID
        createdBy
        sortOrder
        depth
        itemCount
        lastActivityAt
        createdAt
        updatedAt
        __typename
      }
      subFolders {
        nextToken
        __typename
      }
      folderItems {
        nextToken
        __typename
      }
      sortOrder
      depth
      itemCount
      lastActivityAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFILECABINETFOLDER = /* GraphQL */ `
  mutation DeleteFILECABINETFOLDER(
    $input: DeleteFILECABINETFOLDERInput!
    $condition: ModelFILECABINETFOLDERConditionInput
  ) {
    deleteFILECABINETFOLDER(input: $input, condition: $condition) {
      id
      name
      description
      parentFolderID
      clientID
      organizationID
      createdBy
      parentFolder {
        id
        name
        description
        parentFolderID
        clientID
        organizationID
        createdBy
        sortOrder
        depth
        itemCount
        lastActivityAt
        createdAt
        updatedAt
        __typename
      }
      subFolders {
        nextToken
        __typename
      }
      folderItems {
        nextToken
        __typename
      }
      sortOrder
      depth
      itemCount
      lastActivityAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFILECABINETITEM = /* GraphQL */ `
  mutation CreateFILECABINETITEM(
    $input: CreateFILECABINETITEMInput!
    $condition: ModelFILECABINETITEMConditionInput
  ) {
    createFILECABINETITEM(input: $input, condition: $condition) {
      id
      folderID
      folder {
        id
        name
        description
        parentFolderID
        clientID
        organizationID
        createdBy
        sortOrder
        depth
        itemCount
        lastActivityAt
        createdAt
        updatedAt
        __typename
      }
      certificateID
      documentID
      documentType
      documentName
      clientID
      addedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFILECABINETITEM = /* GraphQL */ `
  mutation UpdateFILECABINETITEM(
    $input: UpdateFILECABINETITEMInput!
    $condition: ModelFILECABINETITEMConditionInput
  ) {
    updateFILECABINETITEM(input: $input, condition: $condition) {
      id
      folderID
      folder {
        id
        name
        description
        parentFolderID
        clientID
        organizationID
        createdBy
        sortOrder
        depth
        itemCount
        lastActivityAt
        createdAt
        updatedAt
        __typename
      }
      certificateID
      documentID
      documentType
      documentName
      clientID
      addedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFILECABINETITEM = /* GraphQL */ `
  mutation DeleteFILECABINETITEM(
    $input: DeleteFILECABINETITEMInput!
    $condition: ModelFILECABINETITEMConditionInput
  ) {
    deleteFILECABINETITEM(input: $input, condition: $condition) {
      id
      folderID
      folder {
        id
        name
        description
        parentFolderID
        clientID
        organizationID
        createdBy
        sortOrder
        depth
        itemCount
        lastActivityAt
        createdAt
        updatedAt
        __typename
      }
      certificateID
      documentID
      documentType
      documentName
      clientID
      addedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFILECABINETACTIVITY = /* GraphQL */ `
  mutation CreateFILECABINETACTIVITY(
    $input: CreateFILECABINETACTIVITYInput!
    $condition: ModelFILECABINETACTIVITYConditionInput
  ) {
    createFILECABINETACTIVITY(input: $input, condition: $condition) {
      id
      action
      folderID
      itemID
      itemType
      itemName
      performedBy
      details
      clientID
      organizationID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFILECABINETACTIVITY = /* GraphQL */ `
  mutation UpdateFILECABINETACTIVITY(
    $input: UpdateFILECABINETACTIVITYInput!
    $condition: ModelFILECABINETACTIVITYConditionInput
  ) {
    updateFILECABINETACTIVITY(input: $input, condition: $condition) {
      id
      action
      folderID
      itemID
      itemType
      itemName
      performedBy
      details
      clientID
      organizationID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFILECABINETACTIVITY = /* GraphQL */ `
  mutation DeleteFILECABINETACTIVITY(
    $input: DeleteFILECABINETACTIVITYInput!
    $condition: ModelFILECABINETACTIVITYConditionInput
  ) {
    deleteFILECABINETACTIVITY(input: $input, condition: $condition) {
      id
      action
      folderID
      itemID
      itemType
      itemName
      performedBy
      details
      clientID
      organizationID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDOCUMENTREQUEST = /* GraphQL */ `
  mutation CreateDOCUMENTREQUEST(
    $input: CreateDOCUMENTREQUESTInput!
    $condition: ModelDOCUMENTREQUESTConditionInput
  ) {
    createDOCUMENTREQUEST(input: $input, condition: $condition) {
      id
      clientID
      clientVendorID
      projectID
      requestType
      categories {
        category
        description
        required
        __typename
      }
      requestedBy
      requestedByEmail
      requestedAt
      uploadToken
      tokenUsed
      tokenExpiresAt
      uploadedAt
      status
      emailSentAt
      emailReadAt
      emailOpenCount
      vendorEmail
      vendorName
      clientName
      notes
      associatedCertificateIds
      certificateDetails
      totalFilesRequested
      totalFilesUploaded
      uploads {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDOCUMENTREQUEST = /* GraphQL */ `
  mutation UpdateDOCUMENTREQUEST(
    $input: UpdateDOCUMENTREQUESTInput!
    $condition: ModelDOCUMENTREQUESTConditionInput
  ) {
    updateDOCUMENTREQUEST(input: $input, condition: $condition) {
      id
      clientID
      clientVendorID
      projectID
      requestType
      categories {
        category
        description
        required
        __typename
      }
      requestedBy
      requestedByEmail
      requestedAt
      uploadToken
      tokenUsed
      tokenExpiresAt
      uploadedAt
      status
      emailSentAt
      emailReadAt
      emailOpenCount
      vendorEmail
      vendorName
      clientName
      notes
      associatedCertificateIds
      certificateDetails
      totalFilesRequested
      totalFilesUploaded
      uploads {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDOCUMENTREQUEST = /* GraphQL */ `
  mutation DeleteDOCUMENTREQUEST(
    $input: DeleteDOCUMENTREQUESTInput!
    $condition: ModelDOCUMENTREQUESTConditionInput
  ) {
    deleteDOCUMENTREQUEST(input: $input, condition: $condition) {
      id
      clientID
      clientVendorID
      projectID
      requestType
      categories {
        category
        description
        required
        __typename
      }
      requestedBy
      requestedByEmail
      requestedAt
      uploadToken
      tokenUsed
      tokenExpiresAt
      uploadedAt
      status
      emailSentAt
      emailReadAt
      emailOpenCount
      vendorEmail
      vendorName
      clientName
      notes
      associatedCertificateIds
      certificateDetails
      totalFilesRequested
      totalFilesUploaded
      uploads {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDOCUMENTUPLOAD = /* GraphQL */ `
  mutation CreateDOCUMENTUPLOAD(
    $input: CreateDOCUMENTUPLOADInput!
    $condition: ModelDOCUMENTUPLOADConditionInput
  ) {
    createDOCUMENTUPLOAD(input: $input, condition: $condition) {
      id
      documentRequestID
      documentRequest {
        id
        clientID
        clientVendorID
        projectID
        requestType
        requestedBy
        requestedByEmail
        requestedAt
        uploadToken
        tokenUsed
        tokenExpiresAt
        uploadedAt
        status
        emailSentAt
        emailReadAt
        emailOpenCount
        vendorEmail
        vendorName
        clientName
        notes
        associatedCertificateIds
        certificateDetails
        totalFilesRequested
        totalFilesUploaded
        createdAt
        updatedAt
        __typename
      }
      clientID
      clientVendorID
      category
      fileName
      fileSize
      fileType
      s3Key
      s3Bucket
      annotation
      uploadedAt
      uploadedBy
      status
      validationStatus
      validationNotes
      validatedBy
      validatedAt
      previewUrl
      reviewedBy
      reviewedAt
      reviewNotes
      isDeleted
      deletedAt
      deletedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDOCUMENTUPLOAD = /* GraphQL */ `
  mutation UpdateDOCUMENTUPLOAD(
    $input: UpdateDOCUMENTUPLOADInput!
    $condition: ModelDOCUMENTUPLOADConditionInput
  ) {
    updateDOCUMENTUPLOAD(input: $input, condition: $condition) {
      id
      documentRequestID
      documentRequest {
        id
        clientID
        clientVendorID
        projectID
        requestType
        requestedBy
        requestedByEmail
        requestedAt
        uploadToken
        tokenUsed
        tokenExpiresAt
        uploadedAt
        status
        emailSentAt
        emailReadAt
        emailOpenCount
        vendorEmail
        vendorName
        clientName
        notes
        associatedCertificateIds
        certificateDetails
        totalFilesRequested
        totalFilesUploaded
        createdAt
        updatedAt
        __typename
      }
      clientID
      clientVendorID
      category
      fileName
      fileSize
      fileType
      s3Key
      s3Bucket
      annotation
      uploadedAt
      uploadedBy
      status
      validationStatus
      validationNotes
      validatedBy
      validatedAt
      previewUrl
      reviewedBy
      reviewedAt
      reviewNotes
      isDeleted
      deletedAt
      deletedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDOCUMENTUPLOAD = /* GraphQL */ `
  mutation DeleteDOCUMENTUPLOAD(
    $input: DeleteDOCUMENTUPLOADInput!
    $condition: ModelDOCUMENTUPLOADConditionInput
  ) {
    deleteDOCUMENTUPLOAD(input: $input, condition: $condition) {
      id
      documentRequestID
      documentRequest {
        id
        clientID
        clientVendorID
        projectID
        requestType
        requestedBy
        requestedByEmail
        requestedAt
        uploadToken
        tokenUsed
        tokenExpiresAt
        uploadedAt
        status
        emailSentAt
        emailReadAt
        emailOpenCount
        vendorEmail
        vendorName
        clientName
        notes
        associatedCertificateIds
        certificateDetails
        totalFilesRequested
        totalFilesUploaded
        createdAt
        updatedAt
        __typename
      }
      clientID
      clientVendorID
      category
      fileName
      fileSize
      fileType
      s3Key
      s3Bucket
      annotation
      uploadedAt
      uploadedBy
      status
      validationStatus
      validationNotes
      validatedBy
      validatedAt
      previewUrl
      reviewedBy
      reviewedAt
      reviewNotes
      isDeleted
      deletedAt
      deletedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
